/* eslint max-classes-per-file: 0 */

import { User as Data } from '@/typings/api/User'
import { AxiosRequestConfig } from 'axios'
import { BaseApiResponse as BR } from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'

export class AuthServiceApi extends BaseApiAuth<Data> {
  protected readonly endpoint = '/auth/api';

  constructor(
    protected readonly baseURL = [
      window.location.origin,
      process.env.VUE_APP_ADMIN_PORT === '80' ? null : process.env.VUE_APP_ADMIN_PORT,
    ]
      .filter(Boolean)
      .join(':'),
    protected readonly endpointPrefix = process.env.VUE_APP_BASE_AUTH_API_URL_PREFIX,
  ) {
    super(baseURL, endpointPrefix)
  }

  public login(data?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/login'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data, ...config })
  }

  public logout(data?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/logout'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data, ...config })
  }

  public loginAs(username: Data['username'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/login_as'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { data: { username }, params, ...config })
  }

  public logoutAs(params?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/logout_as'
    const [url] = this.getUrl(path)
    return this.request('POST', url, { params, ...config })
  }
}
